import type { WidgetProps } from "@rjsf/core"
import { ToggleSwitchButton } from "dash-styled"

export function CheckboxWidget({ disabled, value, onChange }: WidgetProps) {
    const handleChange = (value: boolean) => {
        if (!disabled) {
            onChange(value)
        }
    }

    const isChecked = typeof value === "boolean" ? value : false

    return (
        <div className="w-auto">
            <ToggleSwitchButton
                fullWidth={false}
                iconSize="lg"
                activeColor="#7638E1"
                className={`w-auto p-0 ${disabled ? "opacity-50" : ""}`}
                value={isChecked}
                onChange={handleChange}
            />
        </div>
    )
}
